// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__7lLtG","description":"NotFoundBlock_description__OFvpb"};